
<section 
  class="custom-route__welcome-planner-view"
 [class.shown]="!isAllReadyViewShown()" 
>
  <app-header />
  
  <app-welcome-planner-items />

  <app-welcome-planner-button />
</section>